import { render, staticRenderFns } from "./BrokerSecondaryUserTerms.vue?vue&type=template&id=229b998c"
import script from "./BrokerSecondaryUserTerms.vue?vue&type=script&lang=js"
export * from "./BrokerSecondaryUserTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports